import App from "./App.vue";
import appData from "./app";
import router from "./router/index";
import ElementPlus from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { createApp } from "vue";
import { ElMessage } from "element-plus";
import { auth, inputNumber } from "./utils/directive"; // 自定义指令
import "element-plus/dist/index.css";
import "./index.scss";

import dayjs from "dayjs";
import "dayjs/locale/zh"; // 引入中文

import BaseTable from "@/components/BaseTable.vue";
import BasePopup from "@/components/BasePopup.vue";
import BaseTopTitle from "@/components/BaseTopTitle.vue";
import BaseDialog from "@/components/BaseDialog.vue";
import BaseTypeList from "@/components/BaseTypeList.vue";
import BaseMeun from "@/components/BaseMeun.vue";
import BaseMeun2 from "@/components/BaseMeun2.vue";
import BaseRegion from "@/components/BaseRegion.vue";
import BaseSelect from "@/components/BaseSelect.vue";
import BaseShopList from "@/components/BaseShopList.vue";
import UpLoad from "@/components/UpLoad.vue";
import LogList from "@/components/LogList.vue";
import BaseBox from "@/components/BaseTableBox.vue";
import BaseCode from "@/components/BaseCode.vue";
import BaseLargeCode from "@/components/BaseLargeCode.vue";
import BaseColorPicker from "@/components/BaseColorPicker.vue";
import BaseNewPopup from "@/components/BaseNewPopup.vue";
import BaseDynamic from "@/components/BaseDynamic.vue";
import BaseNewTable from "@/components/BaseNewTable.vue";
import BaseLog from "@/components/BaseLog.vue";
import BaseUpload from "@/components/BaseUpload.vue";

//pinia
import { createPinia } from "pinia";
const pinia = createPinia();

const app = createApp(App);
interface IMessage {
  success: (val: string | undefined) => void;
  error: (val: string | undefined) => void;
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $app: AppData;
    $message: IMessage;
    $day: any;
  }
}

app.config.globalProperties.$app = appData;
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$day = dayjs;

app.component("VTable", BaseTable);
app.component("VPopup", BasePopup);
app.component("VTopTitle", BaseTopTitle);
app.component("VDialog", BaseDialog);
app.component("VTypeList", BaseTypeList);
app.component("VMeun", BaseMeun);
app.component("VMeun2", BaseMeun2);
app.component("VRegion", BaseRegion);
app.component("VSelect", BaseSelect);
app.component("VShopList", BaseShopList);
app.component("VUpLoad", UpLoad);
app.component("VLogList", LogList);
app.component("VBox", BaseBox);
app.component("VCode", BaseCode);
app.component("VLargeCode", BaseLargeCode);
app.component("ZColorPicker", BaseColorPicker);
app.component("ZPopup", BaseNewPopup);
app.component("ZDynamic", BaseDynamic);
app.component("ZTable", BaseNewTable);
app.component("ZLog", BaseLog);
app.component("ZUpload", BaseUpload);


app.use(auth);
app.use(inputNumber);

app.use(ElementPlus, {
  locale: zhCn,
});
//pinia
app.use(pinia);
app.use(router);
app.config.warnHandler = () => null;
app.mount("#app");
